import { TransportationProps } from 'enums/TransportationEnums';
import { MultipleOriginsProductRawMaterialTransportations } from 'models/MultipleOriginsProductRawMaterialTransportations/multipleOriginsProductRawMaterialTransportations.model';
import { transformedDataTransportation } from '../CreateProductFlowInterfaces';

export const TransformTransportationForm = (
  response: MultipleOriginsProductRawMaterialTransportations[]
) => {
  const data: transformedDataTransportation = {
    ingredients: [],
    packageMaterials: [],
  };
  response.forEach(item => {
    if (item.type === TransportationProps.INGREDIENT) {
      const ingredientMultipleOrigins = item?.multipleOrigin?.map(multipleOrigin => multipleOrigin &&
      {
        ...multipleOrigin, supplier: multipleOrigin.supplierId
          ? { label: multipleOrigin.supplier, value: multipleOrigin.supplierId }
          : undefined, id:multipleOrigin?.id
      }
      )
      data.ingredients.push({
        id: item.id,
        type: item.type,
        ingredientName: item.activityLabel,
        multipleOrigin: ingredientMultipleOrigins
      });
    }
    else if (item.type === TransportationProps.PACKAGING) {
      const packingMultipleOrigins = item?.multipleOrigin?.map(multipleOrigin => multipleOrigin &&
        {
          ...multipleOrigin, supplier: multipleOrigin.supplierId
            ? { label: multipleOrigin.supplier, value: multipleOrigin.supplierId }
            : undefined, id:multipleOrigin?.id
        }
        )
      data.packageMaterials.push({
        id: item.id,
        type: item.type,
        packingMaterialName: item.activityLabel,
        multipleOrigin: packingMultipleOrigins
      });
    }
  });

  return data;
};
